// extracted by css-extract-rspack-plugin
export default {"handle":"use-resizable_handle__Tn+c2"};